import { Flex, Typography } from '@iheartjane/reefer';

import type { Flavor } from '@jane/bloom/types/schemas/marketplace/terpenes';
import { FLAVOR_ICONS } from '@jane/bloom/utils/terpenes/constants';

import styles from './flavorCard.module.css';

interface FlavorCardProps {
  flavor: Flavor;
}

export const FlavorCard = ({ flavor }: FlavorCardProps) => {
  const Icon = FLAVOR_ICONS[flavor];

  return (
    <Flex className={styles['flavorCard']}>
      <Icon size="md" />
      <Typography>
        {flavor.charAt(0).toUpperCase() + flavor.slice(1)}
      </Typography>
    </Flex>
  );
};
